<div class="section-title">
  <mat-icon>outgoing_mail</mat-icon>
  <span>Envio ao fornecedor</span>
</div>
<app-action-card icon="mail" title="Email para {{ fornecedorNome || 'o fornecedor' }} nos formatos configurados">
  @if (mostrarBotao) {
    Link do portal, planilha e/ou PDF, conforme a Comunicação de pedido. As alterações são salvas antes do envio.
  } @else {
    O pedido é enviado na etapa de Aprovação, somente depois de aprovado.
  }
  @if (mostrarBotao && !habilitado && motivoBloqueio) {
    <div class="ced-ped-envio__bloqueio">
      <mat-icon class="material-symbols-outlined">lock</mat-icon>
      <span>{{ motivoBloqueio }}</span>
    </div>
  }
  <div cardActions class="ced-ped-envio__actions">
    @switch (envioStatus) {
      @case ('confirmado') {
        <span class="ced-ped-envio__badge ced-ped-envio__badge--ok">
          <mat-icon class="material-symbols-outlined">verified</mat-icon>
          Confirmado {{ envio.datetimeConfirmacao | date: 'dd/MM HH:mm' }}
        </span>
      }
      @case ('enviado') {
        <span class="ced-ped-envio__badge ced-ped-envio__badge--sent">
          <mat-icon class="material-symbols-outlined">mark_email_read</mat-icon>
          Enviado {{ envio.datetimeEnvio | date: 'dd/MM HH:mm' }}
        </span>
      }
      @default {
        <span class="ced-ped-envio__badge">
          <mat-icon class="material-symbols-outlined">schedule_send</mat-icon>
          Aguardando
        </span>
      }
    }
    @if (mostrarBotao) {
      <span [matTooltip]="motivoBloqueio" [matTooltipDisabled]="habilitado || !motivoBloqueio">
        <button mat-flat-button type="button" class="btn-primary btn-spinner" [class.btn-loading]="envio.enviando"
          [disabled]="!podeEnviar" [attr.aria-label]="envio.enviando ? 'Enviando pedido' : null" (click)="abrirEnvioPedido()">
          <mat-icon class="material-symbols-outlined">send</mat-icon>
          {{ envioStatus === 'aguardando' ? 'Enviar pedido' : 'Reenviar' }}
          @if (envio.enviando) { <mat-spinner diameter="20"></mat-spinner> }
        </button>
      </span>
    }
  </div>
</app-action-card>
